module.exports = __webpack_public_path__ + "img/information-circle-gray.04d12f48.svg";